import Swiper, { EffectFade, Navigation } from 'swiper';
import SwiperCore from 'swiper';
SwiperCore.use([EffectFade]);
const caseStudiesSlider = new Swiper('.js-case-studies-slider', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    speed: 1000,
    slidesPerView: 1,
    autoHeight: true,
    modules: [Navigation],
    breakpoints: {
        300: {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});
function initSwipers() {
    new Swiper('.js-testimonials-slider', {
        spaceBetween: 14,
        slidesPerView: 1,
        speed: 1000,
        modules: [Navigation],
        breakpoints: {
            481: {
                slidesPerView: 1,
            },
            300: {
                slidesPerView: 1.2,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    let whyChooseUsSlider = null;
    if (window.innerWidth <= 480) {
        whyChooseUsSlider = new Swiper('.js-why-choose-us-slider', {
            spaceBetween: 12,
            slidesPerView: 1,
            speed: 1000,
            modules: [Navigation],
            breakpoints: {
                481: {
                    slidesPerView: 1,
                },
                300: {
                    slidesPerView: 1.15,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
    window.addEventListener('resize', function () {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 480) {
            if (!whyChooseUsSlider) {
                whyChooseUsSlider = new Swiper('.js-why-choose-us-slider', {
                    spaceBetween: 12,
                    slidesPerView: 1,
                    speed: 1000,
                    modules: [Navigation],
                    breakpoints: {
                        481: {
                            slidesPerView: 1,
                        },
                        300: {
                            slidesPerView: 1.15,
                        },
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            }
        }
        else {
            whyChooseUsSlider.destroy();
            whyChooseUsSlider = undefined;
        }
    });
}
const Sliders = { initSwipers, caseStudiesSlider };
export default Sliders;
